import React from 'react';
import { ArrowClockwise } from '@phosphor-icons/react';
import { Button } from './ui/button';

export const W37LoadNotice = ({ scope, message, retained, loading, onRetry }) => (
  <div role="alert" className="flex flex-wrap items-center justify-between gap-3 border border-amber-300 bg-amber-50 p-4 text-sm text-amber-950" data-testid={`w37-${scope}-error`}>
    <div className="min-w-0 flex-1" data-testid={`w37-${scope}-error-message`}>
      <p>{message}</p>
      {retained && <p className="mt-1 text-xs" data-testid={`w37-${scope}-retained-notice`}>Showing the last loaded data; the latest update is unavailable.</p>}
    </div>
    <Button variant="outline" disabled={loading} onClick={onRetry} data-testid={`w37-${scope}-retry`}>
      <ArrowClockwise size={16} className={loading ? 'mr-2 animate-spin' : 'mr-2'} />
      {loading ? 'Retrying…' : 'Retry'}
    </Button>
  </div>
);
